module.exports = __webpack_public_path__ + "static/media/MC9.8ccd7bc6.jpeg";